define('drops/textArea/textArea',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/richText',
    'lq/required'
], function ($, Drop, Style, richText, Required) {
    'use strict';

    var defaults = {
        data: {
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    var isMaxLengthSupported = 'maxLength' in document.createElement('textarea');

    function TextArea(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        if (this.data.watermark !== "" && this.data.watermark !== null && this.data.watermark !== undefined) {
            this.data.hasPlacehoderSetup = true;
        }
        this.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });
    };

    Drop.extend(TextArea);

    TextArea.typeName = 'TextArea';

    TextArea.prototype.preRender = function () {
        if (!this.data.richText)
            this.createSimpleTextEditor();
        else
            this.createRichTextEditor();

        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();
    };

    TextArea.prototype.focus = function () {
        //hack to set focus at end of textarea
        var value = this.$textArea.val();
        this.$textArea.val("");
        this.$textArea.trigger('focus');
        this.$textArea.val(value);
    };

    TextArea.prototype.getValue = function () {
        if (this.richTextEditor)
            return this.richTextEditor.toString();
        return this.$textArea.val();
    };

    TextArea.prototype.clearValue = function () {
        if (this.$textArea) {
            this.$textArea.val('');
            this.$textArea[0].setAttribute('value', '');
        }
        this.updateRequiredIndicator();
    };

    TextArea.prototype.isInRichTextMode = function () {
        return this.richTextEditor !== undefined && this.richTextEditor !== null;
    };

    TextArea.prototype.switchToRichText = function () {
        if (!this.richTextEditor) {
            this.$textArea.remove();
            this.$textArea = null;

            this.createRichTextEditor();
        }
    };

    TextArea.prototype.switchToSimpleText = function () {
        if (this.richTextEditor) {
            this.richTextEditor.close();
            this.richTextEditor = null;

            this.createSimpleTextEditor();
        }
    };

    TextArea.prototype.setValue = function (update) {
        if (this.data.richText || richText.isRichTextString(update.value)) {
            this.switchToRichText();
            this.richTextEditor.fromString(update.value);
        } else {
            this.switchToSimpleText();
            if (update.value !== null && update.value !== undefined) {
                this.$textArea.val(update.value);
                this.$textArea[0].setAttribute('value', update.value);
            } else {
                this.$textArea.val('');
                this.$textArea[0].setAttribute('value', '');
            }
        }

        this.updateRequiredIndicator();
    };

    TextArea.prototype.createSimpleTextEditor = function () {
        this.$textArea = $('<textarea />')
	        .addClass('boxToBorderSize not-resizable')
            .attr('id', this.rootDrop.instanceId + '_' + this.data.id)
            .attr('tabindex', this.data.tabIndex)
			.attr('placeholder', this.data.watermark)
	        .addClass(this.data.hasPlacehoderSetup ? 'placeholderSetup' : '')
            .css({
                width: '100%',
                height: '100%',
                overflowX: 'hidden'
            })
            .val(this.data.defaultValue || '')
            .appendTo(this.$element);

        this.$textArea[0].setAttribute('value', this.data.defaultValue || '');

        var self = this;
        var cutToMaxLengthIfOver = function () {
            if (self.$textArea.val().length > self.data.maxLength)
                self.$textArea.val(self.$textArea.val().substr(0, self.data.maxLength));
        };

        if (this.data.hasMaxLength) {
            // note: the 'maxlength' attribute is not supported by all browsers (e.g. IE9 and lower)
            if (isMaxLengthSupported)
                this.$textArea.attr('maxLength', this.data.maxLength);
            else
                this.$textArea
                    .on('keypress paste change compositionupdate', function () {
                        _.defer(cutToMaxLengthIfOver);
                    });
        }

        this.$textArea.on('keyup', function () {
            self.updateRequiredIndicator();
            $(this)[0].setAttribute('value', $(this).val());
        });

        if (this.data.readOnly)
            this.$textArea.prop('readonly', true);

        this.applyEventTrigger('focusLost', 'blur', this.$textArea);

        var changedEvent = this.getEventDataFor('changed');
        if (changedEvent.enabled) {
            this.subscribeEventHandler(this.$textArea, 'keydown', function () {
                if (!_.has(self, 'lastChangedEventValue'))
                    self.lastChangedEventValue = self.getValue();
            });
            this.subscribeEventHandler(this.$textArea, 'keypress input', _.debounce(function () {
                if (self.lastChangedEventValue !== self.getValue()) {
                    self.lastChangedEventValue = self.getValue();
                    self.triggerEvent(changedEvent.raisedEventName);
                }
            }, 300));
        }

        var enterPressedEvent = this.getEventDataFor('enterPressed');
        if (enterPressedEvent.enabled) {
            this.$textArea.on('keyup', function (event) {
                if (event.keyCode === 13) {
                    self.triggerEvent(enterPressedEvent.raisedEventName);
                }
            });
        }

        Style.renderStyles(self, null, self.$textArea);
    };

    TextArea.prototype.createRichTextEditor = function () {
        this.richTextEditor = new richText.RichTextEditor({
            parentElement: this.$element,
            sections: this.data.sections,
            editable: this.data.readOnly !== true,
            simpleRichTextEditor: this.data.simpleRichTextEditor,
            placeholder: this.data.richTextPlaceholder
        });
        Style.renderStyles(this, null, this.richTextEditor.$element);

        var eventData = this.getEventDataFor('focusLost');
        var self = this;
        if (eventData.enabled) {
            this.richTextEditor.withOnFocusLost(function () {
                self.triggerEvent(eventData.raisedEventName);
            });
        }
    };

    TextArea.prototype.setPlaceholder = function (val) {
        if (this.$textArea) this.$textArea.attr('placeholder', val);
    };

    return TextArea;
});
